import { useState } from 'react';
import { Grid, DialogActions, DialogContent, Button, FormControl } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap } from '@tap/mui-ui';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { CommentEditor, useComment } from '@tap/doc-ui';

/*
*   Диалог: Удалить запись о результате контроля качества
*/


type DeleteQCResultDialogProps = IDialogProps<{ documentKey: string }, ICancelDialogResult>;

export default function DeleteQCResultDialog({
    data,
    isOpen,
    handleClose,
}: DeleteQCResultDialogProps) {

    const [isLoading, setIsLoading] = useState(false);

    const commentState = useComment({ documentKeys: [data.documentKey], actionCode: 'delete_qc_result' });

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }

    const handleMainAction = () => {
        setIsLoading(true);
        return Promise.resolve(data.documentKey)
            .then(() => {
                commentState.addComment();
            })
            .then(() => {
                setIsLoading(false);
                handleClose({ isCancel: false });
            });
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
        >

            <DialogTitleCustom
                primaryText={'Вы действительно хотите удалить результат контроля качества?'}
            />

            <DialogContent>
                <Grid
                    item
                    container
                    spacing={2}
                    alignItems='stretch'
                >
                    <FieldWrap label={'Комментарий'}>
                        <FormControl sx={{ width: '100%' }}>
                            <CommentEditor {...commentState} />
                        </FormControl>
                    </FieldWrap>

                </Grid>
            </DialogContent>

            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    <Button
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={handleMainAction}
                        sx={{ mr: 2 }}
                    >
                        Удалить
                    </Button>

                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>

                </Grid>
            </DialogActions>

        </DialogCustom >
    );
}
